import { useEffect, useState } from 'react'
import {  CssBaseline } from '@mui/material'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { GOOGLE_CLIENT_ID } from './constant';
import AppRouter from './router/router'
import { useUser } from './providers/user-provider';
import { useGetProfile } from './react-query/auth-queries';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from './theme/customizations';
import AppTheme from './shared-theme/AppTheme';
import { PlayerProvider } from './providers/player-provider';
import GlobalPlayer from './components/player/GlobalPlayer';
import { Toaster } from 'react-hot-toast';

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};



function App() {
  const { token, setUser } = useUser(); 
  const [isAuthenticated, setIsAuthenticated] = useState(!!token?.['accessToken']); 

  const { data: profile,error } = useGetProfile({
    enabled: !!token?.['accessToken'] || !!token?.['refreshToken'],
  });

  useEffect(() => {
    if (profile && profile.success && profile.data) {
      // profile is ApiResponse<UserResponse>, so profile.data IS the User object
      setUser(profile.data);
      setIsAuthenticated(true);
    }
  }, [profile, setUser]);

  useEffect(() => {
    if (error) {
      localStorage.removeItem("accessToken");
    }
  }, [error]);

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AppTheme themeComponents={xThemeComponents}>
        <PlayerProvider>
            <CssBaseline enableColorScheme />
            <Toaster position="bottom-right" reverseOrder={false} />
            <AppRouter isAuthenticated={isAuthenticated} />
            <GlobalPlayer />
        </PlayerProvider>
      </AppTheme>
    </GoogleOAuthProvider>
  );
}

export default App;
